import { useMemo } from 'react';
import { useCurrentUser } from './queries';
import { userWithInitials } from 'utils/userUtils';

/**
 * Hook to get current user with calculated initials
 * @returns {Object} Object containing user data with initials, loading state, and error
 */
export function useCurrentUserWithInitials() {
  const { data: user, isLoading, error, ...rest } = useCurrentUser();
  
  const userWithInitialsData = useMemo(() => {
    return userWithInitials(user);
  }, [user]);
  
  return {
    data: userWithInitialsData,
    user: userWithInitialsData, // Alias for easier migration
    isLoading,
    error,
    ...rest
  };
}